const STORAGE_KEY = '@egerdau-web/tipo-compra-map';
const LAST_KEY = '@egerdau-web/tipo-compra-last';

type TipoCompraMap = Record<string, string>;

function getMap(): TipoCompraMap {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) ?? '{}');
  } catch {
    return {};
  }
}

export function setTipoCompraForItemId(itemId: number, value: string): void {
  const map = getMap();
  map[String(itemId)] = value;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
}

export function getTipoCompraForItemId(
  itemId: number,
  fallback: string,
  sku?: string
): string {
  const map = getMap();
  return map[String(itemId)] ?? (sku ? map[sku] : undefined) ?? fallback;
}

export function setTipoCompraForSku(sku: string, value: string): void {
  const map = getMap();
  map[sku] = value;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
}

export function migrateTipoCompraFromSkuToItemId(
  sku: string,
  itemId: number
): void {
  const map = getMap();
  if (!(sku in map)) return;
  map[String(itemId)] = map[sku];
  delete map[sku];
  localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
}

export function setLastTipoCompra(value: string): void {
  localStorage.setItem(LAST_KEY, value);
}

export function getLastTipoCompra(fallback: string): string {
  return localStorage.getItem(LAST_KEY) ?? fallback;
}

export function clearTipoCompraMap(): void {
  localStorage.removeItem(STORAGE_KEY);
  localStorage.removeItem(LAST_KEY);
}
